export default "__VITE_ASSET__BCLgpypU__"